export default function (Component) {
Component.options.__docs = "<p>The <code>FdTimeItem</code> is used in the popover to pick time that is associated with the <code>FdTimePicker</code> component. </p>\n<pre><code><span class=\"hljs-section\">&lt;FdTimeItem /&gt;</span></code></pre>"
}